import angular from 'angular'

import { LeadsPolicyModule } from '../leads/policy/leads-policy.module'

import { AdjustDivisionRotationsModalComponent } from './adjust-rotations-form/adjust-division-rotations-modal.component';
import { EditDivisionContainerComponent } from './edit-division/edit-division-container.component';
import { EditDivisionComponent } from './edit-division/edit-division.component';
import { EditDivisionProfileComponent } from './edit-division-profile/edit-division-profile.component';
import { EditDivisionLeadsPolicyContainerComponent } from './edit-division/edit-division-leads-policy-container.component';
import { EditDivisionProfilePayrollPolicyHistoryModalComponent } from './edit-division-profile-payroll-policy-history/edit-division-profile-payroll-policy-history-modal.component';
import { ListDivisionsContainerComponent } from './list-division/list-divisions-container.component';

export const DivisionModule = angular
    .module("apex.mainApp.division", [
        // The module makes use of edit components to make changes to the division leads policy.
        LeadsPolicyModule
    ])
    .component("apexAdjustDivisionRotationsModal", AdjustDivisionRotationsModalComponent)
    .component("apexEditDivisionProfilePayrollPolicyHistoryModal",
        EditDivisionProfilePayrollPolicyHistoryModalComponent)
    .component("apexEditDivisionContainer", EditDivisionContainerComponent)
    .component("apexEditDivision", EditDivisionComponent)
    .component("apexEditDivisionProfile", EditDivisionProfileComponent)
    .component("apexEditDivisionLeadsPolicyContainer", EditDivisionLeadsPolicyContainerComponent)
    .component("apexListDivisionsContainer", ListDivisionsContainerComponent)
    .name
